import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import '../css/basicDetailsForm.scss'
import './../assets/css/font-awesome.min.css'
import { createStudent } from '../actions/studentActions'
import { useStateValue } from '../state'
import {
  validatePincode,
  validateTextInput,
  validateSelectInput,
  validatePersonFormErrors,
  validateMailId,
  validateDistrict,
  validateVillage,
  validateCenterName,
  validateCourseName,
} from '../utils/validation'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import { getDistrict } from '../actions/cityVillageActions'
import { getCenter } from '../actions/nearestCenterActions'
import { getCourse } from '../actions/interestedCourseActions'

const PersonForm = props => {
  const { userData, student } = props
  const [firstName, setFirstName] = useState(student?.firstName)
  const [dob] = useState(userData?.dob)
  const [mobileNumber] = useState(userData?.mobileNumber)
  const [language] = useState(userData?.language)
  const [lastName, setLastName] = useState('')
  const [{ jwtToken }, dispatch] = useStateValue()
  const [highestQualification, setQualification] = useState('')
  const [pincode, setPincode] = useState('')
  const [gender, setGender] = useState('')
  const [errors, setErrors] = useState({})
  const [address, setAddress] = useState('')
  const [mailId, setMailId] = useState('')
  const [district, setDistrict] = useState('')
  const { t, i18n } = useTranslation()
  const lng = window.localStorage.getItem('lng')
  const [accepted, setAccepted] = useState(false)

  const [village, setVillage] = useState('')
  const [{ cityVillageDetails }] = useStateValue()

  //set state for center name and fetch value from reducer
  const [nearestCenter, setNearestCenter] = useState('')
  const [{ nearestCenterDetails }] = useStateValue()

  //set state for interested course and fetch value from reducer
  const [interestedCourse, setInterestedCourse] = useState('')
  const [{ interestedCourseDetails }] = useStateValue()

  //adding new fields to set state and city name internally(without ui).
  let stateName = ''
  let cityName = ''

  const qualificationOptions = [
    { value: 'Uneducated', label: 'No Formal Education' },
    { value: 'Below 5th Standard', label: 'Below 5th Standard' },
    { value: '5th Standard Passed', label: '5th Standard Passed' },
    { value: '7th Standard Passed', label: '7th Standard Passed' },
    { value: '8th Standard Failed', label: '8th Standard Failed' },
    { value: '8th Standard Passed', label: '8th Standard Passed' },
    { value: '9th Standard Passed', label: '9th Standard Passed' },
    { value: '10th Standard Passed', label: '10th Standard Passed' },
    { value: '12th Standard', label: '12th Standard' },
    { value: 'Below 12th Standard', label: 'Below 12th Standard' },
    { value: '12th Passed - science', label: '12th Passed - science' },
    { value: '12th Passed - Non-science', label: '12th Passed - Non-science' },
    { value: '12th Standard Passed', label: '12th Standard Passed' },
    { value: 'CSTI Certified', label: 'CSTI Certified' },
    { value: 'Diploma', label: 'Diploma' },
    { value: 'ITI', label: 'ITI' },
    { value: 'Professional', label: 'Professional' },
    { value: 'Degree', label: 'Degree' },
    { value: 'BSC - science', label: 'BSC - science' },
    { value: 'BSC - Non-science', label: 'BSC - Non-science' },
    { value: '2 Years Diploma', label: '2 Years Diploma' },
    { value: 'Bachelors Degree 2nd Year', label: 'Bachelors Degree 2nd Year' },
    { value: 'Bachelors Degree 3rd Year', label: 'Bachelors Degree 3rd Year' },
    { value: 'Bachelors Degree 4th Year', label: 'Bachelors Degree 4th Year' },
    { value: 'Bachelors Degree 5th Year', label: 'Bachelors Degree 5th Year' },
    { value: 'Graduate', label: 'Graduate' },
    { value: 'Masters Degree 1st Year', label: 'Masters Degree 1st Year' },
    { value: 'Masters Degree 2nd Year', label: 'Masters Degree 2nd Year' },
    { value: 'Post Graduate', label: 'Post Graduate' },
  ]

  const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Others', label: 'Others' },
  ]

  const districtOptions = [
    { value: 'Enter Pinode', label: 'Enter Pincode' },
    { value: 'Ambala', label: 'Ambala' },
    { value: 'Bhiwani', label: 'Bhiwani' },
    { value: 'Charkhi Dadri', label: 'Charkhi Dadri' },
    { value: 'Faridabad', label: 'Faridabad' },
    { value: 'Fatehabad', label: 'Fatehabad' },
    { value: 'NorGurugram (Gurgaon)', label: 'Gurugram (Gurgaon)' },
    { value: 'Hisar', label: 'Hisar' },
    { value: 'Jhajjar', label: 'Jhajjar' },
    { value: 'Jind', label: 'Jind' },
    { value: 'Kaithal', label: 'Kaithal' },
    { value: 'Karnal', label: 'Karnal' },
    { value: 'Kurukshetra', label: 'Kurukshetra' },
    { value: 'Mahendragarh', label: 'Mahendragarh' },
    { value: 'Nuh', label: 'Nuh' },
    { value: 'Palwal', label: 'Palwal' },
    { value: 'Panchkula', label: 'Panchkula' },
    { value: 'Panipat', label: 'Panipat' },
    { value: 'Rewari', label: 'Rewari' },
    { value: 'Rohtak', label: 'Rohtak' },
    { value: 'Sirsa', label: 'Sirsa' },
    { value: 'Sonipat', label: 'Sonipat' },
    { value: 'Yamunanagar', label: 'Yamunanagar' },
  ]

  const getStudentData = () => ({
    firstName,
    lastName,
    highestQualification,
    gender,
    dob,
    mobileNumber,
    pincode,
    address,
    district,
    village,
    stateName,
    cityName,
    nearestCenter,
    interestedCourse,
    mailId,
    language,
  })

  //setting reference variable here.
  const selectDistrictRef = useRef()
  const pincodeRef = useRef()
  const mailIdRef = useRef()
  const selectVillageRef = useRef()
  const selectStateNameRef = useRef()
  const selectCityNameRef = useRef()
  const selectNearestCenterRef = useRef()
  const selectCourseNameRef = useRef()

  var myDist = {}
  useEffect(() => {
    if (pincode.length === 6) {
      getDistrict(dispatch, jwtToken, pincode, errors?.pincode?.length)
      getCenter(dispatch, jwtToken, pincode, stateName, errors?.pincode?.length)
      getCourse(dispatch, jwtToken, pincode, errors?.pincode?.length)
    }

    if (district === '') {
      const error = (errors['district'] = '* Mandatory field')
      setErrors(error)
      // setDistrict( (getDistrictName(cityVillageDetails).length!=0) ? getDistrictName(cityVillageDetails) : setErrors({error}))
    }
    if (mailId === '') {
      if (errors?.mailId !== '') {
        const error = (errors['mailId'] = '')
        setErrors(error)
      }
    }
  }, [pincode, district])

  const saveStudent = event => {
    event.preventDefault()

    mailIdRef?.current?.focus()
    var error = {}
    // console.log(cityVillageDetails?.cityVillageList[0]?.state)

    if (district === '') {
      setDistrict(cityVillageDetails?.cityVillageList[0]?.district)
    }

    const student = { ...getStudentData() }
    // console.log(student)

    if (
      student.mailId === '' ||
      (student.mailId !== '' &&
        validateMailId(student.mailId)?.mailId?.length < 1)
    ) {
      if (!validatePersonFormErrors(errors))
        if (
          student?.district?.length === 0 &&
          cityVillageDetails?.cityVillageList[0]?.district !== undefined
        ) {
          createStudent(
            dispatch,
            jwtToken,
            student,
            cityVillageDetails?.cityVillageList[0]?.district
          )
        } else {
          createStudent(dispatch, jwtToken, student, student?.district)
        }
    } else {
      alert('Form has one or more errors please check to proceed')
    }
  }

  const onChangePincode = event => {
    if (event?.target?.value || event?.target?.value?.length === 0) {
      const errors = validatePincode(event?.target?.value, lng)
      setErrors(errors)
      setPincode(event?.target?.value)
    }
    if (pincode.length !== 6) {
      setDistrict('')
      setVillage('')
      setInterestedCourse('')
      setNearestCenter('')
      selectDistrictRef?.current?.select?.clearValue()
      selectVillageRef?.current?.select?.clearValue()
      selectStateNameRef?.current?.select?.clearValue()
      selectCityNameRef?.current?.select?.clearValue()
      selectNearestCenterRef?.current?.select?.clearValue()
      selectCourseNameRef?.current?.select?.clearValue()
    }
  }

  const onChangeFirstName = event => {
    if (event?.target?.value || event?.target?.value?.length === 0) {
      const errors = validateTextInput('firstName', event?.target?.value, lng)
      setErrors(errors)
      setFirstName(event?.target?.value)
    }
  }

  const onChangeLastName = event => {
    if (event?.target?.value || event?.target?.value?.length === 0) {
      const errors = validateTextInput('lastName', event?.target?.value, lng)
      setErrors(errors)
      setLastName(event?.target?.value)
    }
  }

  const onChangeHighestQualification = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateSelectInput('highestQualification', event?.value)
      setErrors(errors)
      setQualification(event?.value)
    }
  }

  const onChangeGender = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateSelectInput('gender', event?.value)
      setErrors(errors)
      setGender(event?.value)
    }
  }

  const onChangeDistrict = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateDistrict(event?.value, lng)
      setErrors(errors)
      setDistrict(event?.value)
    }
  }

  const onChangeMailId = event => {
    if (event?.target?.value || event?.target?.value?.length === 0) {
      const errors = validateMailId(event?.target?.value, lng)
      setErrors(errors)
      setMailId(event?.target?.value)
    }
  }

  const onChangeVillage = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateVillage(event?.value, lng)
      setErrors(errors)
      setVillage(event?.value)
    }
  }

  //added handler to set center name
  const onChangeNearestCenter = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateCenterName('nearestCenter', event?.value, lng)
      setErrors(errors)
      setNearestCenter(event?.value, console.log(event?.value))
    }
  }

  //added handler to set interested course name
  const onChangeInterestedCourse = event => {
    if (event?.value || event?.value?.length === 0) {
      const errors = validateCourseName('interestedCourse', event?.value, lng)
      setErrors(errors)
      setInterestedCourse(event?.value)
    }
  }

  const getVillageNameList = cityVillageDetails => {
    if (!cityVillageDetails) return []
    if (!cityVillageDetails?.cityVillageList) return []
    if (
      cityVillageDetails?.cityVillageList &&
      Object.keys(cityVillageDetails?.cityVillageList).length === 0 &&
      cityVillageDetails?.cityVillageList === Object
    )
      return []
    return cityVillageDetails?.cityVillageList.map(villageNames => ({
      value: villageNames.cityVillage,
      label: villageNames.cityVillage,
    }))
  }

  const getNearestCenterList = nearestCenterDetails => {
    if (!nearestCenterDetails) return []
    if (!nearestCenterDetails?.centerNameList) return []
    if (
      nearestCenterDetails?.centerNameList &&
      Object.keys(nearestCenterDetails?.centerNameList).length === 0 &&
      nearestCenterDetails?.centerNameList === Object
    )
      return []
    return nearestCenterDetails?.centerNameList.map(nearestCenter => ({
      value: nearestCenter.name,
      label: nearestCenter.name,
    }))
  }

  const getDistrictNameList = cityVillageDetails => {
    var DistrictList = []
    if (!cityVillageDetails) return []
    if (!cityVillageDetails?.cityVillageList) return []
    if (
      cityVillageDetails?.cityVillageList &&
      Object.keys(cityVillageDetails?.cityVillageList).length === 0 &&
      cityVillageDetails?.cityVillageList === Object
    )
      return []
    cityVillageDetails?.cityVillageList?.map(dataValue => {
      if (!DistrictList.find(value => value.label === dataValue.district)) {
        DistrictList.push({
          value: dataValue.district,
          label: dataValue.district,
        })
      }
    })
    return DistrictList
  }
  const getDistrictName = cityVillageDetails => {
    if (!cityVillageDetails) return ''
    if (!cityVillageDetails?.cityVillageList) return ''
    if (!cityVillageDetails?.cityVillageList[0]?.district) return ''
    return cityVillageDetails?.cityVillageList[0]?.district
  }

  //adding course names using digihub api
  const getInterestedCourseList = interestedCourseDetails => {
    if (!interestedCourseDetails) return []
    if (!interestedCourseDetails?.courseNameList) return []
    if (
      interestedCourseDetails?.courseNameList &&
      Object.keys(interestedCourseDetails?.courseNameList).length === 0 &&
      interestedCourseDetails?.courseNameList === Object
    )
      return []

    return interestedCourseDetails?.courseNameList.map(interestedCourse => ({
      value: interestedCourse.name,
      label: interestedCourse.name,
    }))
  }

  //get statename
  const getStateNameList = cityVillageDetails => {
    var StateList = []
    if (!cityVillageDetails) return []
    if (!cityVillageDetails?.cityVillageList) return []
    if (
      cityVillageDetails?.cityVillageList &&
      Object.keys(cityVillageDetails?.cityVillageList).length === 0 &&
      cityVillageDetails?.cityVillageList === Object
    )
      return []
    cityVillageDetails?.cityVillageList?.map(dataValue => {
      if (!StateList.find(value => value.label == dataValue.state)) {
        StateList.push({
          value: dataValue.state,
          label: dataValue.state,
        })
      }
    })
    stateName = cityVillageDetails?.cityVillageList[0]?.state
    // console.log(stateName)
    return StateList
  }

  const getStateName = cityVillageDetails => {
    if (!cityVillageDetails) return ''
    if (!cityVillageDetails?.cityVillageList) return ''
    if (!cityVillageDetails?.cityVillageList[0]?.state) return ''
    return cityVillageDetails?.cityVillageList[0]?.state
  }

  const getCityNameList = cityVillageDetails => {
    var CityList = []
    if (!cityVillageDetails) return []
    if (!cityVillageDetails?.cityVillageList) return []
    if (
      cityVillageDetails?.cityVillageList &&
      Object.keys(cityVillageDetails?.cityVillageList).length === 0 &&
      cityVillageDetails?.cityVillageList === Object
    )
      return []
    cityVillageDetails?.cityVillageList?.map(dataValue => {
      if (!CityList.find(value => value.label === dataValue.taluk)) {
        CityList.push({
          value: dataValue.taluk,
          label: dataValue.taluk,
        })
      }
    })
    cityName = cityVillageDetails?.cityVillageList[0]?.taluk
    //console.log(cityName)
    return CityList
  }

  const getCityName = cityVillageDetails => {
    if (!cityVillageDetails) return ''
    if (!cityVillageDetails?.cityVillageList) return ''
    if (!cityVillageDetails?.cityVillageList[0]?.taluk) return ''
    return cityVillageDetails?.cityVillageList[0]?.taluk
  }

  return (
    <div className="person_screen_body">
      <form onSubmit={saveStudent}>
        <div className="bold-blue-heading center_aligned">
          {t('form_heading')}
        </div>
        <div class="required_header_text">{t('mandatoryFields')}</div>

        <div className="person_screen_row">
          <div
            className="person_screen_column"
            style={{ display: 'inline-block' }}
          >
            <label for="firstName" className="basicForm-label">
              {t('firstName')}
              <span class="mandatory"> * </span>
            </label>
            <input
              className="basicForm-input"
              placeholder={t('firstNamePlaceHolder')}
              type="text"
              value={firstName}
              maxLength="25"
              name="name"
              required
              onChange={onChangeFirstName}
            />
            {errors?.firstName ? (
              <div
                className="basic-input-error"
                style={{ display: 'block', textAlign: 'right' }}
              >
                {errors.firstName}
              </div>
            ) : null}
          </div>
          <div
            className="person_screen_column"
            style={{ display: 'inline-block' }}
          >
            <label for="lastName" className="basicForm-label">
              {t('lastName')}
              <span class="mandatory"> * </span>{' '}
            </label>
            <input
              className="basicForm-input"
              placeholder={t('lastNamePlaceHolder')}
              value={lastName}
              maxLength="25"
              name="name"
              required
              onChange={e => onChangeLastName(e)}
            />
            {errors?.lastName ? (
              <div
                class="basic-input-error"
                style={{ display: 'block', textAlign: 'right' }}
              >
                {errors.lastName}
              </div>
            ) : null}
          </div>
        </div>

        <div class="person_screen_row">
          <div className="person_screen_column">
            <label for="qualification" className="basicForm-label">
              {t('qualification')} <span class="mandatory"> * </span>
            </label>
            <Select
              className="basicForm-select"
              options={qualificationOptions}
              required
              onChange={e => onChangeHighestQualification(e)}
            />
            {errors?.highestQualification ? (
              <div class="basic-input-error">{errors.highestQualification}</div>
            ) : null}
          </div>
          <div className="person_screen_column">
            <label for="gender" className="basicForm-label">
              {t('gender')} <span class="mandatory"> * </span>
            </label>
            <Select
              className="basicForm-select"
              options={genderOptions}
              required
              onChange={e => onChangeGender(e)}
            />
            {errors?.gender ? (
              <div class="basic-input-error">{errors.gender}</div>
            ) : null}
          </div>
        </div>

        <div class="person_screen_row">
          <div
            className="person_screen_column"
            style={{ display: 'inline-block' }}
          >
            <label for="pincode" className="basicForm-label">
              {t('pincode')} <span class="mandatory"> * </span>
            </label>
            <input
              className="basicForm-input"
              placeholder={t('pincodePlaceHolder')}
              value={pincode}
              maxLength="6"
              name="pincode"
              required
              onChange={e => onChangePincode(e)}
            />
            {errors?.pincode ? (
              <div
                className="basic-input-error"
                style={{ display: 'block', textAlign: 'right' }}
              >
                {errors.pincode}
              </div>
            ) : null}
          </div>
          {(pincode.length < 6 || pincode.length === 6) &&
            getVillageNameList(cityVillageDetails).length === 0 && (
              <div
                className="person_screen_column"
                style={{ display: 'inline-block' }}
              >
                <label for="village" className="basicForm-label">
                  {t('village')}
                </label>
                <input
                  className="basicForm-input"
                  placeholder={t('villagePlaceHolder')}
                  type="text"
                  value={village}
                  name="village"
                  onChange={e => onChangeVillage(e?.target)}
                />
                {errors?.village ? (
                  <div
                    className="basic-input-error"
                    style={{ display: 'block', textAlign: 'right' }}
                  >
                    {errors.village}
                  </div>
                ) : null}
              </div>
            )}
          {getVillageNameList(cityVillageDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="village" className="basicForm-label">
                {t('village')}{' '}
              </label>
              <Select
                className="basicForm-select"
                ref={selectVillageRef}
                options={getVillageNameList(cityVillageDetails)}
                onChange={e => onChangeVillage(e)}
              />
            </div>
          )}
        </div>

        <div style={{ display: 'none' }} class="person_screen_row">
          {getStateName(cityVillageDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="state" className="basicForm-label">
                State
              </label>
              <Select
                className="basicForm-select"
                placeholder="State"
                options={getStateNameList(cityVillageDetails)}
                ref={selectStateNameRef}
                name="state"
                id="state"
                value={getStateNameList(cityVillageDetails)}
                defaultValue={getStateNameList(cityVillageDetails)}
              />
            </div>
          )}
          {getStateName(cityVillageDetails).length === 0 && (
            <div className="person_screen_column">
              <label for="state" className="basicForm-label">
                State
              </label>
              <Select
                className="basicForm-select"
                placeholder="state"
                options={getStateNameList}
                defaultValue={getStateNameList(cityVillageDetails)}
              />
            </div>
          )}
        </div>

        <div style={{ display: 'none' }} class="person_screen_row">
          {getCityName(cityVillageDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="city" className="basicForm-label">
                City
              </label>
              <Select
                className="basicForm-select"
                placeholder="city"
                ref={selectCityNameRef}
                name="cityName"
                id="city"
                value={getCityNameList(cityVillageDetails)}
                options={getCityNameList(cityVillageDetails)}
                defaultValue={getCityNameList(cityVillageDetails)}
              />
            </div>
          )}
          {getCityName(cityVillageDetails).length === 0 && (
            <div className="person_screen_column">
              <label for="city" className="basicForm-label">
                City
              </label>
              <Select
                className="basicForm-select"
                placeholder="city"
                options={getCityNameList(cityVillageDetails)}
                defaultValue={getCityNameList(cityVillageDetails)}
              />
            </div>
          )}
        </div>

        {/* adding nearest center field */}
        <div class="person_screen_row">
          <div
            className="person_screen_column"
            style={{ display: 'inline-block' }}
          >
            <label for="mailId" className="basicForm-label">
              {t('mailId')}
            </label>
            <input
              className="basicForm-input"
              placeholder={t('mailIdPlaceHolder')}
              value={mailId}
              maxLength="50"
              name="mailId"
              ref={mailIdRef}
              onChange={e => onChangeMailId(e)}
            />
            {errors?.mailId ? (
              <div
                className="basic-input-error"
                style={{ display: 'block', textAlign: 'right' }}
              >
                {errors.mailId}
              </div>
            ) : null}
          </div>

          {/* adding course name option */}
          {getInterestedCourseList(interestedCourseDetails).length === 0 && (
            <div
              className="person_screen_column"
              style={{ display: 'inline-block' }}
            >
              <label for="interestedCourse" className="basicForm-label">
                {t('interestedCourse')}
              </label>
              <input
                className="basicForm-input"
                placeholder={t('interestedCourse')}
                type="text"
                isDisabled
                value={interestedCourse}
                name="interestedCourse"
                onChange={e => onChangeInterestedCourse(e?.target)}
              />
            </div>
          )}
          {getInterestedCourseList(interestedCourseDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="interestedCourse" className="basicForm-label">
                {t('interestedCourse')}{' '}
              </label>
              <Select
                className="basicForm-select"
                ref={selectCourseNameRef}
                options={getInterestedCourseList(interestedCourseDetails)}
                onChange={e => onChangeInterestedCourse(e)}
              />
            </div>
          )}
        </div>

        <div class="person_screen_row">
          {getDistrictName(cityVillageDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="district" className="basicForm-label">
                {t('district')} <span class="mandatory"> * </span>
              </label>
              <Select
                className="basicForm-select"
                placeholder={t('districtPlaceHolder')}
                required
                options={getDistrictNameList(cityVillageDetails)}
                ref={selectDistrictRef}
                name="district"
                id="district1"
                onChange={e => onChangeDistrict(e)}
              />
              <p>
                <span>
                  {errors?.district ? (
                    <div
                      className="basic-input-error"
                      style={{ display: 'block', textAlign: 'right' }}
                    >
                      {errors.district}
                    </div>
                  ) : null}
                </span>
              </p>
            </div>
          )}
          {getDistrictName(cityVillageDetails).length === 0 && (
            <div className="person_screen_column">
              <label for="district" className="basicForm-label">
                {t('district')} <span class="mandatory"> * </span>
              </label>

              <Select
                className="basicForm-select"
                placeholder={t('districtPlaceHolder')}
                options={districtOptions}
                required
                isDisabled
                onChange={e => onChangeDistrict(e)}
              />
            </div>
          )}

          {(pincode.length < 6 || pincode.length === 6) &&
            getNearestCenterList(nearestCenterDetails).length === 0 && (
              <div
                className="person_screen_column"
                style={{ display: 'inline-block' }}
              >
                <label for="nearestCenter" className="basicForm-label">
                  {t('nearestCenter')}
                </label>
                <input
                  className="basicForm-input"
                  placeholder={t('nearestCenter')}
                  type="text"
                  value={nearestCenter}
                  name="nearestCenter"
                  isDisabled
                  onChange={e => onChangeNearestCenter(e?.target)}
                />
                {errors?.nearestCenter ? (
                  <div
                    className="basic-input-error"
                    style={{ display: 'block', textAlign: 'right' }}
                  >
                    {errors.nearestCenter}
                  </div>
                ) : null}
              </div>
            )}
          {getNearestCenterList(nearestCenterDetails).length !== 0 && (
            <div className="person_screen_column">
              <label for="nearestCenter" className="basicForm-label">
                {t('nearestCenter')}{' '}
              </label>
              <Select
                className="basicForm-select"
                ref={selectNearestCenterRef}
                options={getNearestCenterList(nearestCenterDetails)}
                onChange={e => onChangeNearestCenter(e)}
              />
            </div>
          )}
        </div>

        <div class="person_screen_row">
          <div className="person_screen_column">
            <label for="dob" className="basicForm-label">
              {t('dob')}
            </label>
            <input
              value={userData?.dob}
              name="dob"
              disabled="true"
              className="basicForm-input"
            />
          </div>
          <div className="person_screen_column">
            <label for="mobileNumber" className="basicForm-label">
              {t('mobileNumber')}
            </label>
            <input
              className="basicForm-input"
              value={userData?.mobileNumber}
              name="mobileNumber"
              disabled="true"
            />
          </div>
        </div>

        <div class="row_center">
          <div>
            <div class="required_header_text">&nbsp;</div>
            {validatePersonFormErrors(errors) ? (
              <div className="center_aligned">
                <button type="submit" class="submit-grey">
                  {t('save')}
                </button>
              </div>
            ) : (
              <div>
                <button type="submit" class="submit-blue">
                  {t('save')}
                </button>
              </div>
            )}
          </div>

          <div class="required_header_text">&nbsp;</div>
        </div>
      </form>
    </div>
  )
}

export default PersonForm